import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  SEARCH_PRODUCT_REQUESTED,
  SEARCH_PRODUCT_SUCCESS,
  SEARCH_PRODUCT_FAILURE,
  FIND_PRODUCT_INVENTORIES_REQUESTED,
  FIND_PRODUCT_INVENTORIES_SUCCESS,
  FIND_PRODUCT_INVENTORIES_FAILURE,
  DELETE_PRODUCT_METAFIELD_REQUESTED,
  DELETE_PRODUCT_METAFIELD_SUCCESS,
  UPDATE_SELECTED_ITEMS,
  SCAN_PRODUCT_REQUESTED,
  SCAN_PRODUCT_SUCCESS,
  SCAN_PRODUCT_FAILURE,
  RESET_PRODUCTS_STATE,
} from '../types';

export const searchProductsRequested = () => {
  return {
    type: SEARCH_PRODUCT_REQUESTED
  }
};

export const searchProductsSuccess = (products) => {
  return {
    type: SEARCH_PRODUCT_SUCCESS,
    payload: products
  }
};

export const searchProductsFailure = () => {
  return {
    type: SEARCH_PRODUCT_FAILURE
  }
};

export const inventoryDetailsRequested = () => {
  return {
    type: FIND_PRODUCT_INVENTORIES_REQUESTED
  }
}

export const inventoryDetailsSuccess = (payload) => {
  return {
    type: FIND_PRODUCT_INVENTORIES_SUCCESS,
    payload: payload
  }
}


export const productMetadataDeleteRequested = (productId, variationId, metafieldId) => {
  return {
    type: DELETE_PRODUCT_METAFIELD_REQUESTED,
    productId: productId,
    variationId: variationId,
    metafieldId: metafieldId,
  }
}

export const productMetadataDeleteSuccess = (payload) => {
  return {
    type: DELETE_PRODUCT_METAFIELD_SUCCESS,
    payload: payload
  }
}

export const setSelectedItems = (items) => {
  return {
    type: UPDATE_SELECTED_ITEMS,
    payload: items
  }
}

export const scanProductRequested = () => {
  return {
    type: SCAN_PRODUCT_REQUESTED
  }
};

export const scanProductSuccess = (product) => {
  return {
    type: SCAN_PRODUCT_SUCCESS,
    payload: product
  }
};

export const scanProductFailure = (message) => {
  return {
    type: SCAN_PRODUCT_FAILURE,
    message: message
  }
};

export const resetState = () => {
  return {
    type: RESET_PRODUCTS_STATE,
  }
}

export const searchProducts = (ecwidPayload, searchTerm, filterInStock, filterCategory) => {
  return (dispatch) => {
    if (searchTerm === '' && !filterCategory) {
      return dispatch(searchProductsSuccess({ products: null }));
    }

    dispatch(searchProductsRequested());

    let endPoint = Config.baseUrl + Config.productSearch;
    let headers = Object.assign(Config.headers);
    headers.payload = ecwidPayload;

    return Axios.post(endPoint, { 'term': searchTerm, 'in_stock': filterInStock, 'category': filterCategory } , { headers: headers })
      .then((response) => {
        dispatch(searchProductsSuccess(response.data));
      });
  }
}

export const updateSelectedItems = (items) => {
  return (dispatch) => {
    dispatch(setSelectedItems(items));
  }
}

export const scanProduct = (signedPayload, scanTerm, supplierId, settings) => {
  return (dispatch) => {
    dispatch(scanProductRequested());

    let endPoint = Config.baseUrl + Config.productScan;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    let body = {
      'barcode': scanTerm,
      'supplierId': supplierId,
    }

    return Axios.post(endPoint, body, { headers: headers })
      .then((response) => {
        let related_metadata = null;

        if(response.data.metafield_result === null) {
          return dispatch(scanProductFailure('No supplier assignments found for the scanned item.'));
        }

        let item = {};
        let options = null;
        let foundItem = null;
        let variation = null;
        let supplierMetafield = null;

        if(response.data.scan_result.sku_results.length > 0) {
          foundItem = response.data.scan_result.sku_results[0];
        } else {
          foundItem = response.data.scan_result.upc_results[0];
        }

        supplierMetafield = response.data.metafield_result.find(field => field.supplier_id === supplierId);

        if(supplierMetafield.variation_id) {
          variation = foundItem.combinations.find(combo => combo.id === parseInt(supplierMetafield.variation_id));
          options = variation.options;
        }


        item.productId = foundItem.id;
        item.variationId = supplierMetafield.variation_id || null;
        item.productName = foundItem.name;
        item.imageUrl = variation?.smallThumbnailUrl || foundItem.smallThumbnailUrl;
        item.options = options;
        item.sku = variation?.sku || foundItem.sku;
        item.upc = variation?.upc || foundItem.upc;
        item.supplier_sku = supplierMetafield.body.supplier_sku;
        item.supplier_price = supplierMetafield.body.supplier_price;
        item.minimumOrder = supplierMetafield.body.minimum_order;

        if(settings?.settings?.order_multiples) {
          item.orderMultiple = supplierMetafield.body.order_multiple;
        }

        if(settings?.settings?.pack_quantities) {
          item.packQuantity = supplierMetafield.body.pack_quantity;
        }

        dispatch(scanProductSuccess(item));
      });

  }
}

export const inventoryDetails = (signedPayload, productId, variationId) => {
  return (dispatch) => {
    dispatch(inventoryDetailsRequested(`${productId}/${variationId}`));

    let endPoint = Config.baseUrl + Config.product + Config.inventory + `?product_id=${productId}`;

    if(variationId) {
      endPoint = endPoint + `&variation_id=${variationId}`
    }

    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(inventoryDetailsSuccess(response.data));
      })
  }
}

export const deleteMetadata = (signedPayload, productId, variationId, metafieldId) => {
  return (dispatch) => {
    dispatch(productMetadataDeleteRequested(productId, variationId, metafieldId));

    let endPoint = Config.baseUrl + Config.product + Config.metafield + `?metafield_id=${metafieldId}&product_id=${productId}`;

    if(variationId) {
      endPoint = endPoint + `&variation_id=${variationId}`
    }

    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.delete(endPoint, { headers: headers })
      .then((response) => {
        dispatch(productMetadataDeleteSuccess(response));
      })
  }
}

export const resetProducts = () => {
  return (dispatch)  =>{
    dispatch(resetState());
  }
}